import { useRef, useState } from "react";
import { useAppSelector } from "redux-share/hooks";
import useOnClickOutside from "helpers/hooks/useOnClickOutside";
import { conditions } from "helpers";
import { ConditionName, IDownloadLinks, zIndex } from "interfaces";
import { shallowEqual } from 'react-redux';
import dynamic from "next/dynamic";

const Popover = dynamic(() => import("../popover/popover"));
const DownloadIcon = dynamic(() => import("../../icon-components/downloadIcon"));

const Download = () => {

    const [showDownloadPopover, setShowDownloadPopover] = useState<boolean>(false);

    const { details } = useAppSelector(({ videoData: { details, isComplexPortrait, isComplexDesktop } }) => ({ details, isComplexPortrait, isComplexDesktop }), shallowEqual);

    const downloadRef = useRef(null);

    useOnClickOutside(downloadRef, () => {
        if (showDownloadPopover) setShowDownloadPopover(false);
    });

    let downloadContent:any = null;
    const downloadIcon = (
        <div className="pl-flex pl-items-center pl-gap-[14px] pl-rounded-[20px] pl-text-secondary-700 dark:pl-text-secondary-50 pl-bg-gray-100 dark:pl-bg-dark-3 pl-px-4 pl-py-[7px] pl-cursor-pointer" onClick={() => setShowDownloadPopover((prev: boolean) => !prev)}>
            <DownloadIcon className={`pl-fill-z-gray-500 dark:pl-fill-dark-5 ${conditions(ConditionName.isComplexPortrait) ? "pl-w-4 pl-h-4" : "pl-w-[22px] pl-h-[22px]"}`}/>
            <p className="pl-whitespace-nowrap">دانلود</p>
        </div>
    )

    if (conditions(ConditionName.isComplexDesktop)) {
        downloadContent = (
            <div className="pl-relative" style={{zIndex: zIndex.download}} ref={downloadRef}>
                {downloadIcon}
                {showDownloadPopover && (
                    <div
                        className={`pl-flex pl-flex-col pl-gap-[6px] pl-pt-[8px] pl-pb-[11px] pl-absolute pl-top-[110%] pl-left-0 pl-bg-gray-highLight dark:pl-bg-dark-2 pl-w-max pl-rounded-[8px]`}
                        style={{ boxShadow: "2px 3px 3px rgba(74, 74, 74, 0.5)" }}
                    >
                        {details.download_links.map((link: IDownloadLinks) => (
                            <a key={link.quality} href={link.link} className="pl-relative pl-flex pl-items-center pl-gap-3 pl-w-full hover:pl-bg-dark-8 hover:dark:pl-bg-main pl-cursor-pointer pl-transition-colors pl-duration-300 pl-px-5 pl-py-[3px]" onClick={() => setShowDownloadPopover(false)}>
                                <span className="pl-text-secondary-700 dark:pl-text-secondary-50 pl-text-[12px] pl-font-normal">{`با کیفیت ${link.quality}`}</span>
                            </a>
                        ))}
                    </div>
                )}
            </div>
        )
    } else if (conditions(ConditionName.isComplexPortrait)) {
        downloadContent = (
            <>
                {downloadIcon}
                <Popover
                    status={showDownloadPopover}
                    isBlurBackground={true}
                    ref={downloadRef}
                    onClose={() => setShowDownloadPopover(false)}
                    type="modal"
                >
                    <div className="pl-py-4">
                        <p className="pl-text-[15px] pl-font-medium pl-mb-4 pl-pr-4">انتخاب کیفیت دانلود</p>
                        <div className="pl-flex pl-flex-col pl-gap-3">
                            {details.download_links.map((link: IDownloadLinks) => (
                                <a key={link.quality} href={link.link} className="pl-w-full pl-py-[3px] pl-pr-4 active:pl-bg-main pl-transition-colors pl-duration-300" onClick={() => setShowDownloadPopover(false)}>
                                    <span className="pl-text-secondary-700 dark:pl-text-secondary-50 pl-text-[14px] pl-font-medium">{`با کیفیت ${link.quality}`}</span>
                                </a>
                            ))}
                        </div>
                    </div>
                </Popover>
            </>
        )
    }

    return <>{downloadContent}</>
}

export default Download;